export default (bookings, localePath) => bookings.map(booking => ({
  id: booking.id,
  images: {
    small: booking.room.roomImage.smallPng,
    medium: booking.room.roomImage.mediumPng,
    large: booking.room.roomImage.largePng,
    xlarge: booking.room.roomImage.xlargePng
  },
  fromDate: booking.startDate,
  toDate: booking.endDate,
  name: booking.room.name,
  house: booking.hotel.venue.name,
  houseColor: booking.hotel.venue.colors.dark,
  to: localePath({ name: 'bedrooms-bookings-id', params: { id: booking.id } })
}))
